import React from 'react';
import { motion } from 'framer-motion';
import { reveal } from '../utils/motion';
import { CaseStudyCard } from '../components/CaseStudyCard';
import { SiteHeader } from '../components/SiteHeader';
import { DrawnUnderline } from '../components/DrawnUnderline';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { caseStudies, heroMetrics } from '../data/caseStudies';
import { clientLogos } from '../data/clientLogos';
import { linkClass } from '../utils/linkClass';
export function Home() {
  return <div className="min-h-screen w-full bg-white font-sans text-ink" data-id="element-138" data-mp="24hk7bdldhjku">
      <div className="mx-auto flex max-w-[1347px] flex-col gap-[30px] px-5 py-10 md:px-10" data-id="element-139" data-mp="29fvgdm3ufq20">
        <SiteHeader data-id="element-140" data-mp="2dhywwp5ddku5" />

        <main className="flex flex-col gap-[30px]" data-id="element-141" data-mp="2dii1z59x8eqr">
          <section className="flex flex-col items-start gap-6 py-10 min-[700px]:flex-row min-[700px]:items-center min-[700px]:gap-10 md:py-20" data-id="element-142" data-mp="3kvac6mkbgbvj">
            <motion.img src="https://cdn.magicpatterns.com/uploads/oThdsUnkXC7FRqpUL19do3/Meikson-Square.jpg" alt="Portrait of Michael Meikson" className="aspect-square w-[160px] shrink-0 rounded-full object-cover min-[700px]:w-[200px]" initial={{
            opacity: 0,
            x: -40
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={reveal} data-id="element-143" data-mp="3ovkik0c0t4ax" />
            <div className="flex max-w-[880px] flex-1 flex-col gap-5" data-id="element-144" data-mp="2mwqql7nfr238">
              <motion.div className="flex flex-col gap-3" initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              ...reveal,
              delay: 0.05
            }} data-id="element-145" data-mp="2hyyvk4rhuzut">
                <h1 className="text-headline font-semibold" data-id="element-146" data-mp="288dtu8gixf7o">
                  18 years of experience across B2B SaaS, fintech, and healthcare.
                </h1>
                <p className="text-subhead text-muted" data-id="element-147" data-mp="1z6ea38e4jx11">
                  Specialize in driving business results through{' '}
                  <DrawnUnderline data-id="element-148" data-mp="1u94m7x6dvtfb">improved usability</DrawnUnderline>.
                </p>
              </motion.div>
            </div>
          </section>

          <motion.section aria-label="Clients" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          ...reveal,
          delay: 0.15
        }} data-id="element-149" data-mp="1omu1ebulbx3g">
            <ul className="grid grid-cols-3 items-center gap-x-4 gap-y-2 md:grid-cols-6" data-id="element-150" data-mp="1fl4b59cg3479">
              {clientLogos.map(logo => <li key={logo.name} className="flex items-center justify-center" data-id="element-151" data-mp="23bqieyemkkg7">
                  <img src={logo.src} alt={logo.name} className="block aspect-[2/1] w-full max-w-[200px] object-contain" data-id="element-152" data-mp="2899w9x7euv7m" />
                </li>)}
            </ul>
          </motion.section>

          <ul aria-label="Results" className="grid w-full grid-cols-1 gap-[30px] sm:grid-cols-3" data-id="element-153" data-mp="1yjgn12uqqs6j">
            {heroMetrics.map((m, i) => <motion.li key={m.label} className="flex flex-col rounded-[30px] bg-positive-bg p-5 [container-type:inline-size]" initial={{
            opacity: 0,
            y: 24
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            ...reveal,
            delay: 0.3 + i * 0.06
          }} data-id="element-154" data-mp="2m89jd0f9z21o" data-mpi={i}>
                <span className="whitespace-nowrap text-[clamp(22px,21cqw,40px)] font-normal leading-[1.35] tracking-[-0.02em] text-positive" data-id="element-155" data-mp="oedt3iipx6sm">
                  {m.value}
                </span>
                <span className="text-xl leading-[27px] tracking-[-0.02em]" data-id="element-156" data-mp="3sru67flrywg2">{m.label}</span>
              </motion.li>)}
          </ul>

          <section aria-label="Case studies" className="flex flex-col gap-[30px]" data-id="element-157" data-mp="3nv3qwuhso4vp">
            {caseStudies.map(study => <CaseStudyCard key={study.id} study={study} animate data-id="element-158" data-mp="ojht5e1rqah" />)}
          </section>

          <section className="flex flex-col gap-[30px] pt-2" data-id="element-159" data-mp="1h2t4lv2n56z7">
            <div className="flex flex-col gap-3" data-id="element-160" data-mp="1h18echnd0a75">
              <h2 className="text-headline font-semibold" data-id="element-161" data-mp="1c484rwrawpba">
                AI has become the core of my design practice.
              </h2>
              <p className="text-subhead text-muted" data-id="element-162" data-mp="27fg1uhd5ps0p">
                I prototype in code and can ship working software.
              </p>
            </div>
            <div className="grid grid-cols-1 gap-[30px] md:grid-cols-[minmax(0,1fr)_minmax(0,2fr)]" data-id="element-163" data-mp="2hccft2ltr6cn">
              <div className="flex flex-col gap-10" data-id="element-164" data-mp="2mboxza1r3p8w">
              <div className="flex flex-col gap-4 text-base leading-[1.6]" data-id="element-165" data-mp="2mcgwotqna33e">
                <p data-id="element-166" data-mp="2qbzevhr3002j">
                  My primary design tool is Magic Patterns, where I maintain working prototypes of client projects. 
                </p>
                <a href="https://project-unified-inbox-with-filtering-117.magicpatterns.app/" target="_blank" rel="noopener noreferrer" className={`w-fit text-base ${linkClass}`} data-id="element-167" data-mp="302u2oqjz77q3">
                  View RSI Prototype →
                </a>
              </div>
              <div className="flex flex-col gap-4 text-base leading-[1.6]" data-id="element-168" data-mp="3e34rlo1q6c8m">
                <p data-id="element-169" data-mp="12f8bk1w724bc">
                  I built Percelo, an AEO (Answer Engine Optimization), tool solo in about two weeks with Claude Code. 
                </p>
                <a href="https://www.percelo.com" target="_blank" rel="noopener noreferrer" className={`w-fit text-base ${linkClass}`} data-id="element-170" data-mp="yfr638grp766">
                  Try Percelo →
                </a>
              </div>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/8x9mJt8jkvyUyDgp9GG3CK/Percelo-hero2.png" alt="Percelo AI visibility report open on a laptop" className="h-[325px] w-full self-start rounded-[30px] object-cover object-[50%_45%]" data-id="element-171" data-mp="1h44ke162rld0" />
            </div>
          </section>

          <TestimonialsSection data-id="element-172" data-mp="24u8jbv8biwxo" />
        </main>

        <div className="pt-10" data-id="element-173" data-mp="202qm9i9f1ghz">
          <SiteHeader as="footer" data-id="element-174" data-mp="201p9n9cr4ly5" />
        </div>
      </div>
    </div>;
}